// Small global patch to avoid "ResizeObserver loop completed with undelivered notifications." crashing app.
// Safe to load once at app start (e.g. in src/index.js). This preserves normal behavior while swallowing the known benign error.
(function patchResizeObserver() {
	/* eslint-disable no-undef */
	if (typeof window === 'undefined') return;
	const OriginalRO = window.ResizeObserver;
	if (!OriginalRO) return;

	try {
		// Avoid double-patching
		if (window.__patchedResizeObserver) return;
		window.__patchedResizeObserver = true;

		window.ResizeObserver = class SafeResizeObserver extends OriginalRO {
			constructor(callback) {
				// wrap original callback with try/catch that swallows the specific browser warning
				const safeCallback = function(entries, observer) {
					try {
						return callback(entries, observer);
					} catch (err) {
						// Ignore the benign ResizeObserver loop error message produced by some Chromium builds
						const msg = err && err.message;
						if (typeof msg === 'string' && msg.includes('ResizeObserver loop completed with undelivered notifications')) {
							// swallow silently
							return;
						}
						// rethrow other errors
						throw err;
					}
				};
				super(safeCallback);
			}
		};
	} catch (e) {
		// fallback: if subclassing fails in some environment, try monkey-patching observe to wrap callbacks
		try {
			const proto = OriginalRO.prototype;
			const origObserve = proto.observe;
			if (origObserve && !proto.__patchedObserve) {
				proto.__patchedObserve = true;
				proto.observe = function() {
					// this.callback is internal; cannot access reliably — best-effort: call original
					try {
						return origObserve.apply(this, arguments);
					} catch (err) {
						const msg = err && err.message;
						if (typeof msg === 'string' && msg.includes('ResizeObserver loop completed with undelivered notifications')) {
							return;
						}
						throw err;
					}
				};
			}
		} catch (e2) {
			// give up silently; nothing more we can do here
		}
	}
	/* eslint-enable no-undef */
})();
